import React from "react";
import queryString from "query-string";
import axios from "axios";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../Styles/details.css"

class Details extends React.Component {
    constructor() {
        super();
        this.state = {
            restaurants: {},
        }
    }
    componentDidMount() {
        const qs = queryString.parse(this.props.location.search);
        const { restaurants } = qs;

        // axios({
        //     method: 'GET',
        //     url: 'http://localhost:9900/restaurants/',restauranta,
        //     headers: { 'Content-Type': 'application/json' }
        // })
        //     .then(response => {
        //         console.log(this.state.restaurants);
        //         this.setState({ restaurants : response.data.restaurants});
                
        //     })
        //     .catch(err => console.log(err));


            axios({
                method: 'GET',
                url: 'https://bee-node107.onrender.com/getRestaurants',
                params: { restaurants: restaurants },
    
                headers: { 'Content-Type': 'application/json' }
            })
                .then(response => {
                    console.log("response")
    
                    console.log(response.data)
                    this.setState({ restaurants: response.data });
                })
                .catch(err => console.log(err));

    }
    render() {
        const { restaurants } = this.state;
        return (
            <div className="up">
                
                    <img className="snack" src={restaurants.image} alt="no img" />
                 
                
                
                <div className="heading">{restaurants.name} </div>


                <Tabs className="tabs">
                    <TabList className="buttoons">
                        <Tab type="button" className="buttoon">Overview</Tab>
                        <Tab type="button" className="buttoon">Contact</Tab>
                    </TabList>
                

                <TabPanel>
                    <p className="about">About this place</p>
                    <p className="head">Rating:</p>
                    <p className="value">{restaurants.aggregate_rating}, {restaurants.rating_text}</p>
                    <p className="head">Average cost:</p>
                    <p className="value">{restaurants.min_price}  for two people(approx)</p>
                </TabPanel>

                <TabPanel>
                    <p className="about">Contact</p>
                    <p className="head">+{restaurants.contact_number} </p>
                    <p className="value">{restaurants.name}</p>
                    <p className="heada">{restaurants.locality}, {restaurants.city}</p>
                    <p className="value">700 for two people(approx)</p>
                </TabPanel>
                </Tabs>
                
            </div>
        )
    }
}


export default Details;